exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#app{background:#fff}.mintui-success{font-size:6.66667vw}", ""]);

